/**
 * Bridge the admin settings store's `localization.language` to i18next, so
 * that switching language in Settings re-renders translated strings without
 * a page reload. Also sets `<html lang="">` for assistive tech / SEO.
 */
import { useEffect } from 'react';
import i18n from '@/src/i18n';
import { useAdminSettings } from '@/src/modules/store/admin-settings.context';

export function useI18nLanguageSync() {
  const { settings } = useAdminSettings();
  const lang = settings.localization.language;
  useEffect(() => {
    if (i18n.language !== lang) {
      void i18n.changeLanguage(lang);
    }
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', lang);
    }
  }, [lang]);
}
